import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/srv/cna/src/components/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/srv/cna/src/components/navigation/index.tsx");
